import { useMutation } from "@tanstack/react-query";
import { authApi } from "@/api";
import { useAuth } from "@/store/authContext";

export function useLogin() {
  const { setSession } = useAuth();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (res) => setSession(res.token, res.user),
  });
}

export function useLogout() {
  const { clearSession } = useAuth();
  return useMutation({
    mutationFn: async () => {
      try {
        await authApi.logout();
      } catch {
        // server-side invalidation is best-effort; always clear locally
      }
    },
    onSettled: () => clearSession(),
  });
}

export function useRegister() {
  return useMutation({
    mutationFn: authApi.register,
  });
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: authApi.forgotPassword,
  });
}
